import React from 'react';
import { Heart, Award, Users } from 'lucide-react';
import { motion } from 'framer-motion';

const About: React.FC = () => {
  return (
    <div className="min-h-screen bg-cream-white">
      <section className="bg-gradient-to-r from-deep-forest to-sky-blue py-16">
        <div className="max-w-7xl mx-auto px-4 text-center">
          <motion.h1
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            className="font-display text-5xl text-white mb-4"
          >
            About Animal Allies
          </motion.h1>
          <motion.p
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.2 }}
            className="text-white/90 text-xl max-w-3xl mx-auto"
          >
            A long-established pillar of the Animal Welfare Community for over 60 years
          </motion.p>
        </div>
      </section>

      <div className="max-w-7xl mx-auto px-4 py-12">
        <div className="bg-white rounded-2xl p-8 shadow-md mb-8">
          <div className="max-w-3xl mx-auto">
            <h2 className="font-display text-3xl text-deep-forest mb-6 text-center">Our Mission</h2>
            <p className="text-xl text-center text-warm-coral font-semibold mb-8">
              "Dedicated to a compassionate journey for pets and people in our community."
            </p>
            
            <p className="text-warm-gray mb-6 leading-relaxed">
              From humble beginnings as a foster-based rescue group to today's bricks and mortar Adoption Center, 
              our commitment to serving the people and pets of the Northland is only growing stronger.
            </p>
            
            <p className="text-warm-gray mb-8 leading-relaxed">
              Animal Allies Humane Society has been serving the Duluth, Minnesota area and lower St. Louis County 
              since 1963. We believe in transparency and are honored to share our work with you.
            </p>

            <div className="grid md:grid-cols-2 gap-6 mb-8">
              <div className="bg-warm-coral/10 rounded-xl p-6">
                <Heart className="text-warm-coral mb-3" size={32} fill="currentColor" />
                <h3 className="font-semibold text-lg text-deep-forest mb-2">Our Goal</h3>
                <p className="text-warm-gray">A loving home for every pet</p>
              </div>
              <div className="bg-sky-blue/10 rounded-xl p-6">
                <Users className="text-sky-blue mb-3" size={32} />
                <h3 className="font-semibold text-lg text-deep-forest mb-2">Our Tagline</h3>
                <p className="text-warm-gray">Bringing Pets and People Together</p>
              </div>
            </div>

            <div className="bg-sage-green/10 rounded-xl p-8 text-center">
              <Award className="text-sage-green mx-auto mb-4" size={48} />
              <h3 className="font-display text-2xl text-deep-forest mb-4">Recognition</h3>
              <p className="text-warm-gray mb-2">
                <span className="font-bold text-sage-green">6 Years in a Row</span>
              </p>
              <p className="text-warm-gray">
                Voted Best Non-Profit Organization by Duluth News Tribune's Best of the Best Contest
              </p>
            </div>
          </div>
        </div>

        <div className="bg-white rounded-2xl p-8 shadow-md">
          <h2 className="font-display text-3xl text-deep-forest mb-6 text-center">Contact Us</h2>
          
          <div className="grid md:grid-cols-2 gap-8 max-w-4xl mx-auto">
            <div>
              <h3 className="font-semibold text-xl text-deep-forest mb-4">Visit Us</h3>
              <p className="text-warm-gray mb-2">4006 Airport Road</p>
              <p className="text-warm-gray mb-4">Duluth, MN 55811</p>
              
              <h4 className="font-semibold text-deep-forest mb-2">Adoption Hours</h4>
              <p className="text-warm-gray">Tuesday-Friday: 12:00-6:00pm</p>
              <p className="text-warm-gray">Saturday-Sunday: 12:00-4:00pm</p>
              <p className="text-warm-gray">Closed Mondays</p>
            </div>
            
            <div>
              <h3 className="font-semibold text-xl text-deep-forest mb-4">Get in Touch</h3>
              <p className="text-warm-gray mb-2">
                <span className="font-semibold">Phone:</span> 218-722-5341
              </p>
              <p className="text-warm-gray mb-2">
                <span className="font-semibold">Email:</span> info@animalallies.net
              </p>
              <p className="text-warm-gray mb-4">
                <span className="font-semibold">Tax ID:</span> 41-0917362
              </p>
              
              <h4 className="font-semibold text-deep-forest mb-2">Executive Director</h4>
              <p className="text-warm-gray">Julie Waltenburg</p>
              <p className="text-warm-gray">juliewaltenb@animalallies.net</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default About;